export default __webpack_public_path__ + "locales/si/ChangeUserStatusDialog.json?hash=497f1accc51a90db3ec33366379ca533";